// const PREFIX = window.LOCALE_PREFIX || '';
const PREFIX =
  window.LOCALE_PREFIX && window.LOCALE_PREFIX !== '/'
    ? window.LOCALE_PREFIX
    : '';
// ============================================
// GLOBAL CART FUNCTIONS (Accessible everywhere)
// ============================================

window.CartFunctions = (function() {
  function getCurrencySymbol(c) {
    const s = {PKR:'Rs', INR:'₹', USD:'$', EUR:'€', GBP:'£'};
    return s[c] || c;
  }

  function formatMoney(cen, s) {
    let a = (cen || 0) / 100;
    return s + ' ' + new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(a);
  }

  function updateCartCount(cart) {
    console.log('Cart updated:', cart.item_count);
    const cartCount = document.getElementById('cart-items-count');
    if(cartCount) {
      cartCount.textContent = cart.item_count;
    }
    document.querySelectorAll('[id*="cart"][id*="count"], .cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });
  }

  function updateCartSummary(cart) {
    const sub = document.querySelector('.cart-drawer__summary-value--subtotal');
    const total = document.querySelector('.cart-drawer__summary-value--total');
    const sym = getCurrencySymbol(cart.currency);
    if(sub) sub.textContent = formatMoney(cart.items_subtotal_price, sym);
    if(total) total.textContent = formatMoney(cart.total_price, sym);
    updateCartCount(cart);
  }

  function bindQtyEvents(container) {
    container.querySelectorAll('.qty-decrease').forEach(b => {
      b.onclick = e => {
        const line = parseInt(b.dataset.line);
        const inp = container.querySelector(`.cart-item__quantity[data-line="${line}"]`);
        let q = parseInt(inp.value) - 1;
        if(q < 0) q = 0;
        changeQty(line, q);
      };
    });

    container.querySelectorAll('.qty-delete').forEach(b => {
      b.onclick = e => {
        const line = parseInt(b.dataset.line);
        changeQty(line, 0);
      };
    });

    container.querySelectorAll('.qty-increase').forEach(b => {
      b.onclick = e => {
        const line = parseInt(b.dataset.line);
        const q = parseInt(container.querySelector(`.cart-item__quantity[data-line="${line}"]`).value) + 1;
        changeQty(line, q);
      };
    });

    container.querySelectorAll('.cart-item__quantity').forEach(inp => {
      inp.onchange = e => {
        const line = parseInt(inp.dataset.line);
        let q = parseInt(inp.value) || 1;
        if(q < 1) q = 1;
        changeQty(line, q);
      };
    });
  }

  async function updateCartRecommendations(cart) {
    const recSection = document.querySelector('#shopify-section-cart-recommendation');
    if(!recSection) return;
    
    try {
      // const response = await fetch(window.location.pathname);
      const response = await fetch(`${PREFIX}${window.location.pathname.replace(PREFIX, '')}`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newRecSection = doc.querySelector('#shopify-section-cart-recommendation');
      
      if(newRecSection) {
        recSection.innerHTML = newRecSection.innerHTML;
        bindQuickAddButtons();
      }
    } catch(e) {
      console.error('Recommendation update error:', e);
    }
  }

  async function updateCartItems(cart) {
  const box = document.querySelector('.cart-drawer__main-content');
  if(!box) return;
  
  const parentContainer = box.parentElement;
  box.style.opacity = 0.4;

  try {
    const response = await fetch(`${PREFIX}/cart?section_id=cart-drawer`);
    const html = await response.text();
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newContent = doc.querySelector('.cart-drawer__main-content');
    
    if(newContent) {
      box.innerHTML = newContent.innerHTML;
      
      bindQtyEvents(document);
      bindQuickAddButtons();
      
      await updateCartRecommendations(cart);
      
      setTimeout(() => {
        box.style.opacity = 1;
        
        cart.items.forEach((item, idx) => {
          let max = item.variant?.inventory_quantity || 9999;
          const inp = document.querySelector(`.cart-item__quantity[data-line="${idx}"]`);
          const inc = document.querySelector(`.qty-increase[data-line="${idx}"]`);
          
          if(inp && inc) {
            if(parseInt(inp.value) >= max) {
              inc.disabled = true;
              inc.classList.add('disabled');
            } else {
              inc.disabled = false;
              inc.classList.remove('disabled');
            }
          }
        });
      }, 80);
    }
  } catch(error) {
    console.error('Cart update error:', error);
    box.style.opacity = 1;
  }
}

  function changeQty(line, qty) {
    fetch(`${PREFIX}/cart/change.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({line: line + 1, quantity: qty})
    })
    .then(r => r.json())
    .then(c => {
      updateCartSummary(c);
      updateCartItems(c);
    });
  }

  function openCart() {
    document.querySelector('.background_overlay')?.classList.add('active');
    document.querySelector('.cart-drawer')?.classList.add('show');
  }

  function closeCart() {
    document.querySelector('.background_overlay')?.classList.remove('active');
    document.querySelector('.cart-drawer')?.classList.remove('show');
  }

  function bindQuickAddButtons() {
  document.querySelectorAll('.size-btn').forEach(b => {
    const newBtn = b.cloneNode(true);
    b.parentNode.replaceChild(newBtn, b);

    newBtn.onclick = e => {
      e.preventDefault();

      const id = newBtn.dataset.id;
      const q = parseInt(newBtn.dataset.quantity) || 1;
      const loader = newBtn.querySelector('.loader');
      const btnText = newBtn.querySelector('.btn-text');
      const btnIcon = newBtn.querySelector('svg');
      if (loader) loader.classList.add('active');
      if (btnText) btnText.style.display = 'none';
      if (btnIcon) btnIcon.style.display = 'none';

      const f = new URLSearchParams({ id: id, quantity: q });

      fetch(`${PREFIX}/cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: f
      })
      .then(r => r.json())
      .then(() => fetch(`${PREFIX}/cart.js`))
      .then(r => r.json())
      .then(c => {
        updateCartItems(c);
        updateCartSummary(c);
        openCart();
      })
      .catch(err => console.error(err))
      .finally(() => {
        if (loader) loader.classList.remove('active');
        if (btnText) btnText.style.display = '';
        if (btnIcon) btnIcon.style.display = '';
      });
    };
  });
}


function bindAjaxCartForms() {
  document.querySelectorAll('form[action*="/cart/add"]').forEach(f => {
    // Skip if already bound
    if (f.dataset.ajaxBound === 'true') return;
    f.dataset.ajaxBound = 'true';

    f.addEventListener('submit', e => {
      e.preventDefault();

      const loader = f.querySelector('.loader');
      const button = f.querySelector('.add-to-cart-btn');
      const btnText = button?.querySelector('.btn-text');
      const btnIcon = button?.querySelector('svg');

      if(loader) loader.classList.add('active');
      if(btnText) btnText.style.display = 'none';
      if(btnIcon) btnIcon.style.display = 'none';

      const id = f.querySelector('[name="id"]').value;
      const quantity = parseInt(f.querySelector('[name="quantity"]').value) || 1;
      const properties = {};

      f.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(inp => {
        let name = inp.name.match(/^properties\[(.*)\]$/);
        if(name) properties[name[1]] = inp.value;
      });

      f.querySelectorAll('input[name^="propertie["]').forEach(inp => {
        let name = inp.name.match(/^propertie\[(.*)\]$/);
        if(name) properties[name[1]] = inp.value;
      });

      fetch(`${PREFIX}/cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          id: id,
          quantity: quantity,
          properties: properties
        })
      })
      .then(r => r.json())
      .then(() => fetch(`${PREFIX}/cart.js`))
      .then(r => r.json())
      .then(c => {
        updateCartItems(c);
        updateCartSummary(c);
        openCart();
      })
      .catch(err => console.error(err))
      .finally(() => {
        if(loader) loader.classList.remove('active');
        if(btnText) btnText.style.display = '';
        if(btnIcon) btnIcon.style.display = '';
      });
    });
  });
}

  // Return public functions
  return {
    getCurrencySymbol,
    formatMoney,
    updateCartCount,
    updateCartSummary,
    updateCartItems,
    changeQty,
    openCart,
    closeCart,
    bindQuickAddButtons,
    bindAjaxCartForms,
    bindQtyEvents
  };
})();

// ============================================
// HEADER & NAVIGATION
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('li.header__menu-item > a');
  const megaMenus = document.querySelectorAll('.mega-menu');
  const navDrawer = document.querySelector('#NavDrawer');
  const hamburger = document.querySelector('button.hamburger');
  const navClose = document.querySelector('button#NavClose');
  const overlay = document.querySelector('.background_overlay');
  const clickOpenedMenus = new Set();

  menuItems.forEach(menuItem => {
    if (menuItem.classList.contains('location')) {
      menuItem.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const menuText = this.textContent.trim();
        
        megaMenus.forEach(megaMenu => {
          if (menuText === megaMenu.getAttribute('data-link').trim()) {
            const isCurrentlyOpen = megaMenu.classList.contains('show');
            
            if (isCurrentlyOpen && clickOpenedMenus.has(megaMenu)) {
              megaMenu.classList.remove('show');
              clickOpenedMenus.delete(megaMenu);
              this.classList.remove('active');
            } else {
              megaMenu.classList.add('show');
              clickOpenedMenus.add(megaMenu);
              this.classList.add('active');
            }
          }
        });
      });
    }
    
    menuItem.addEventListener('mouseenter', function() {
      const menuText = this.textContent.trim();
      megaMenus.forEach(megaMenu => {
        if (menuText === megaMenu.getAttribute('data-link').trim()) {
          megaMenu.classList.add('show');
        }
      });
    });
    
    const parentLi = menuItem.closest('li.header__menu-item');
    if (parentLi) {
      parentLi.addEventListener('mouseleave', () => {
        megaMenus.forEach(m => {
          if (!clickOpenedMenus.has(m)) {
            m.classList.remove('show');
          }
        });
      });
    }
  });

  megaMenus.forEach(megaMenu => {
    megaMenu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    megaMenu.addEventListener('mouseenter', () => megaMenu.classList.add('show'));
    megaMenu.addEventListener('mouseleave', () => {
      if (!clickOpenedMenus.has(megaMenu)) {
        megaMenu.classList.remove('show');
      }
    });
  });

  document.body.addEventListener('click', function(e) {
    const isMenuClick = e.target.closest('li.header__menu-item') || 
                        e.target.closest('.mega-menu') || 
                        e.target.closest('#NavDrawer');
    
    if (!isMenuClick) {
      const locationLinks = document.querySelectorAll('a.header__menu-link.location');
      locationLinks.forEach(link => link.classList.remove('active'));
      
      megaMenus.forEach(megaMenu => {
        if (clickOpenedMenus.has(megaMenu)) {
          megaMenu.classList.remove('show');
          clickOpenedMenus.delete(megaMenu);
        } else {
          megaMenu.classList.remove('show');
        }
      });
    }
  });

  function addSvgToMatchingMobileItems() {
    const megaMenuLinks = Array.from(megaMenus).map(m => m.getAttribute('data-link').trim());
    const mobileMenuItems = document.querySelectorAll('#NavDrawer ul.drawer-menu-list li a');

    mobileMenuItems.forEach(menuItem => {
      const menuText = Array.from(menuItem.childNodes)
        .filter(n => n.nodeType === 3)
        .map(n => n.textContent)
        .join('')
        .trim();
        
      if (megaMenuLinks.includes(menuText)) {
        const parentLi = menuItem.closest('li');
        if (parentLi && !parentLi.querySelector('.mega-menu-arrow')) {
          const svgArrow = document.createElement('span');
          svgArrow.className = 'mega-menu-arrow';
          svgArrow.innerHTML = `<svg width="19" height="33" viewBox="0 0 19 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.36542 32.1792L0 29.8138L13.7242 16.0896L0 2.36542L2.36542 0L18.455 16.0896L2.36542 32.1792Z" fill="#1C1B1F"/></svg>`;
          menuItem.parentNode.insertBefore(svgArrow, menuItem.nextSibling);

          menuItem.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const targetMegaMenu = Array.from(megaMenus).find(m => 
              m.getAttribute('data-link').trim() === menuText
            );
            if (targetMegaMenu) {
              targetMegaMenu.classList.toggle('show');
              svgArrow.classList.toggle('rotated');
            }
          });
        }
      }
    });

    const drawerRows = document.querySelectorAll('#NavDrawer ul.drawer-menu-list li .drawer-link-row');
    drawerRows.forEach(row => {
      row.addEventListener('click', function(e) {
        e.stopPropagation();
        const liText = row.textContent.trim();
        const targetMegaMenu = Array.from(megaMenus).find(m => 
          m.getAttribute('data-link').trim() === liText
        );
        if (targetMegaMenu) targetMegaMenu.classList.add('show');
      });
    });
  }

  addSvgToMatchingMobileItems();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') addSvgToMatchingMobileItems();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (hamburger && navDrawer) {
    hamburger.addEventListener('click', () => {
      navDrawer.classList.add('show');
      overlay?.classList.add('active');
    });
  }

  if (navClose && navDrawer) {
    navClose.addEventListener('click', () => {
      navDrawer.classList.remove('show');
      overlay?.classList.remove('active');
      megaMenus.classList.remove('show');
    });
  }

  if (overlay && navDrawer) {
    overlay.addEventListener('click', () => {
      navDrawer.classList.remove('show');
      overlay.classList.remove('active');
    });
  }
});


// ============================================
//  CHAR COUNTER PDP PAGE
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const checkbox = document.querySelector("#customize_text");
  const input = document.querySelector("#customize_input");
  const counter = document.querySelector(".char-counter");
  if (!checkbox || !input || !counter) return;
  input.removeAttribute("name");
  checkbox.addEventListener("change", function () {
  if (this.checked) {
    input.setAttribute("name", "properties[Message]");
    counter.innerText = `${input.value.length}/30`;

    // Only scroll on mobile and only if input is out of viewport
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const rect = input.getBoundingClientRect();
        const isOutOfViewport = rect.bottom > window.innerHeight || rect.top < 0;
        if (isOutOfViewport) {
          input.scrollIntoView({ behavior: "smooth", block: "nearest" });
          window.scrollBy({ top: 180, behavior: "smooth" });
        }
      }, 100);
    }

  } else {
    input.removeAttribute("name");
    input.value = "";
    counter.innerText = "0/30";
  }
});
  input.addEventListener("input", function () {
    counter.innerText = `${this.value.length}/30`;
  });
});

// ============================================
// CART DRAWER INITIALIZATION
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  const discountInput = document.querySelector('.cart-drawer__discount-input');
  const discountApplyBtn = document.querySelector('.cart-drawer__discount-btn.btn-primary');
  const removeBtn = document.getElementById('remove-discount');

  // Bind initial cart forms
  window.CartFunctions.bindAjaxCartForms();

  // Cart icon click handler
  document.addEventListener('click', (e) => {
    if (window.location.pathname === '/cart') return;
    if (e.target.closest('.header__icon-cart')) {
      e.preventDefault();
      window.CartFunctions.openCart();
    }
    if (e.target.closest('.popup__close-btn') || e.target.closest('.background_overlay')) {
      window.CartFunctions.closeCart();
    }
  });

  // Discount functionality
  discountApplyBtn?.addEventListener('click', e => {
    e.preventDefault();
    const code = discountInput.value.trim();
    if(!code) return;
    window.location.href = `${PREFIX}/checkout?discount=` + encodeURIComponent(code);
  });
  
  removeBtn?.addEventListener('click', () => {
    fetch(`${PREFIX}/discount`, {method: 'DELETE'})
    .then(() => fetch(`${PREFIX}/cart.js`))
    .then(r => r.json())
    .then(c => {
      window.CartFunctions.updateCartSummary(c);
      discountInput.value = '';
    });
  });

  // Initial cart load
  fetch(`${PREFIX}/cart.js`)
    .then(r => r.json())
    .then(c => {
      window.CartFunctions.updateCartSummary(c);
      window.CartFunctions.updateCartItems(c);
    });
});

// ============================================
// COLLECTION SLIDER & RECOMMENDATIONS
// ============================================
(function() {
  const init = () => {
    document.querySelectorAll('.collection-slider').forEach(slider => {
      let wrap = slider.closest('.featured-section-wrapper');
      new Swiper(slider, {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 12,
        navigation: {
          nextEl: wrap.querySelector('.swiper-button-next'),
          prevEl: wrap.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          768: { slidesPerView: wrap.dataset.desktopSlide || 3 },
          480: { slidesPerView: 2 },
          0: { slidesPerView: 1.2 }
        }
      });
    });

    const section = document.querySelector('.product-recommendations');
    if (section) {
      const obs = new IntersectionObserver((en, o) => {
        if (!en[0].isIntersecting) return;
        o.unobserve(section);
        fetch(section.dataset.url)
          .then(r => r.text())
          .then(t => {
            let div = document.createElement('div');
            div.innerHTML = t;
            let rec = div.querySelector('.product-recommendations');
            if (rec && rec.innerHTML.trim().length) {
              section.innerHTML = rec.innerHTML;
              
              // Re-bind cart forms for the newly loaded recommended products
              window.CartFunctions.bindAjaxCartForms();
              window.CartFunctions.bindQuickAddButtons();
              
              document.querySelectorAll('.collection-slider').forEach(slider => {
                let wrap = slider.closest('.featured-section-wrapper');
                new Swiper(slider, {
                  slidesPerView: 1.26,
                  spaceBetween: 20,
                  loop: true,
                  speed: 800,
                  navigation: {
                    nextEl: wrap.querySelector('.swiper-button-next'),
                    prevEl: wrap.querySelector('.swiper-button-prev')
                  },
                  breakpoints: {
                    560: { slidesPerView: 2.1 },
                    991: { slidesPerView: 3 }
                  }
                });
              });
            }
          });
      }, { rootMargin: '0px 0px 200px 0px' });
      obs.observe(section);
    }
  };

  document.addEventListener('DOMContentLoaded', init);
})();

// ============================================
// COLLECTION AJAX FILTER
// ============================================
// document.addEventListener('DOMContentLoaded', function() {
//   const categoryButtons = document.querySelectorAll('.collection__category-btn');
//   const productsWrapper = document.getElementById('collection-products-wrapper');

//   function loadCollection(url) {
//     if (!productsWrapper) return;

//     const productGrid = productsWrapper.querySelector('.collection__grid');
//     if (productGrid) productGrid.classList.add('loading');

//     fetch(url)
//       .then(r => r.text())
//       .then(html => {
//         const doc = new DOMParser().parseFromString(html, 'text/html');
//         const newWrapper = doc.getElementById('collection-products-wrapper');

//         if (newWrapper) {
//           productsWrapper.innerHTML = newWrapper.innerHTML;
//           initPaginationListeners();
//           // Re-bind cart forms after loading new products
//           window.CartFunctions.bindAjaxCartForms();
//         }

//         const newGrid = productsWrapper.querySelector('.collection__grid');
//         if (newGrid) newGrid.classList.remove('loading');

//         window.history.pushState({}, '', url);
//       })
//       .catch(() => {
//         const grid = productsWrapper.querySelector('.collection__grid');
//         if (grid) grid.classList.remove('loading');
//       });
//   }

//   function initPaginationListeners() {
//     document.querySelectorAll('.pagination-btn[data-page-url]').forEach(btn => {
//       btn.addEventListener('click', e => {
//         e.preventDefault();
//         loadCollection(btn.getAttribute('data-page-url'));
//       });
//     });
//   }

//   categoryButtons.forEach(btn => {
//     btn.addEventListener('click', e => {
//       e.preventDefault();

//       categoryButtons.forEach(b =>
//         b.classList.remove('collection__category-btn--active')
//       );

//       btn.classList.add('collection__category-btn--active');

//       const url = btn.getAttribute('data-collection-url');
//       if (url) loadCollection(url);
//     });
//   });

//   initPaginationListeners();

//   window.addEventListener('popstate', () => location.reload());
// });
// ============================================
// COLLECTION AJAX FILTER
// ============================================
const ENABLE_AJAX_FILTER = true; 
const COLLECTION_AJAX_SECTIONS = [
  'collection-products-wrapper',  
  'section-ajax'   
];
document.addEventListener('DOMContentLoaded', function() {
  const categoryButtons = document.querySelectorAll('.collection__category-btn');
  const productsWrapper = document.getElementById('collection-products-wrapper');
  function loadCollection(url) {
    if (!productsWrapper) return;
    const productGrid = productsWrapper.querySelector('.collection__grid');
    if (productGrid) productGrid.classList.add('loading');
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        COLLECTION_AJAX_SECTIONS.forEach(id => {
          const current = document.getElementById(id);
          const updated = doc.getElementById(id);
          if (current && updated) {
            current.innerHTML = updated.innerHTML;
          }
        });
        initPaginationListeners();
        window.CartFunctions.bindAjaxCartForms();
        const newGrid = productsWrapper.querySelector('.collection__grid');
        if (newGrid) newGrid.classList.remove('loading');
        window.history.pushState({}, '', url);
      })
      .catch(() => {
        const grid = productsWrapper.querySelector('.collection__grid');
        if (grid) grid.classList.remove('loading');
      });
  }
  function initPaginationListeners() {
    if (!ENABLE_AJAX_FILTER) return;
    document.querySelectorAll('.pagination-btn[data-page-url]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        loadCollection(btn.getAttribute('data-page-url'));
      });
    });
  }
  categoryButtons.forEach(btn => {
    btn.addEventListener('click', e => {
      if (!ENABLE_AJAX_FILTER) return; 
      e.preventDefault();
      categoryButtons.forEach(b =>
        b.classList.remove('collection__category-btn--active')
      );
      btn.classList.add('collection__category-btn--active');
      const url = btn.getAttribute('data-collection-url');
      if (url) loadCollection(url);
    });
  });
  if (ENABLE_AJAX_FILTER) {
    initPaginationListeners();
    window.addEventListener('popstate', () => location.reload());
  }
});

// ============================================
// QUANTITY UPDATE HELPER
// ============================================
function updateQty(button, change) {
  const input = button.parentElement.querySelector('.collection__qty-number');
  if (!input) return;

  const currentValue = parseInt(input.value, 10) || 1;
  const newValue = currentValue + change;

  if (newValue >= 1) {
    input.value = newValue;
  }
}


/* ============================================
   CART RECOMMENDATIONS (AJAX + SWIPER SUPPORT)
============================================ */

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          const cartHeader = this.querySelector('.cart_recommendation_header');
          if (cartHeader) cartHeader.style.display = 'flex';

          const cartHeaderContent = this.querySelector('.cart_recommendation_content');
          if (cartHeaderContent) cartHeaderContent.style.display = 'block';

          this.initSwiper();
          if (window.CartFunctions?.bindQuickAddButtons) {
            window.CartFunctions.bindQuickAddButtons();
          }
        }

        const miniCartMain = document.querySelector('#CartDrawer');
        if (miniCartMain) {
          miniCartMain.scrollTop -= miniCartMain.scrollHeight;
        }
      })
      .catch(e => console.error('Failed to load recommendations:', e));
  }

  initSwiper() {
    new Swiper('.cart_recommendation', {
      slidesPerView: 1.4,
      spaceBetween: 16,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
}

/* Register custom element safely */
if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}


/* Global Accordion - Smooth Open & Close */
document.querySelectorAll('.global-accordion__item').forEach((item) => {
  const summary = item.querySelector('.global-accordion__head');
  const body = item.querySelector('.global-accordion__body');

  if (!summary || !body || item.dataset.accordionInitialized) return;

  item.dataset.accordionInitialized = 'true';

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    const isOpen = item.open;

    // Clear any previous animation listeners.
    if (body._accordionTransitionHandler) {
      body.removeEventListener(
        'transitionend',
        body._accordionTransitionHandler
      );
      body._accordionTransitionHandler = null;
    }

    if (isOpen) {
      // Animate closing.
      body.style.gridTemplateRows = '0fr';

      const closeAccordion = (event) => {
        if (event.propertyName !== 'grid-template-rows') return;

        item.open = false;
        body.style.removeProperty('grid-template-rows');
        body.removeEventListener('transitionend', closeAccordion);
        body._accordionTransitionHandler = null;
      };

      body._accordionTransitionHandler = closeAccordion;
      body.addEventListener('transitionend', closeAccordion);
    } else {
      // Open the details element first.
      item.open = true;

      // Start from collapsed height.
      body.style.gridTemplateRows = '0fr';
      body.offsetHeight;

      // Animate to full height.
      body.style.gridTemplateRows = '1fr';

      const openAccordion = (event) => {
        if (event.propertyName !== 'grid-template-rows') return;

        body.style.removeProperty('grid-template-rows');
        body.removeEventListener('transitionend', openAccordion);
        body._accordionTransitionHandler = null;
      };

      body._accordionTransitionHandler = openAccordion;
      body.addEventListener('transitionend', openAccordion);
    }
  });
});
